import React from 'react';
export const BonusSection = () => {
  const scrollToPricing = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const baseBonuses = ['Diario de Espiritualidad', 'Predicciones del Zodíaco 2026', 'Planificador Lunar'];
  const extraBonuses = ['Diario de Bruja 2026', 'Manifestaciones Espirituales', 'Diario de Manifestación', 'Manual de Abundancia y Riqueza', 'Planificador de Chakras', 'Planificador de Brujas', 'Guía de Cristales', 'Diario de Hierbas y Aceites Esenciales'];
  return <section className="py-20 px-4 relative z-10 bg-mystic-surfaceDark/80 border-t border-gold-dark/30" data-id="element-30">
      <div className="max-w-5xl mx-auto text-center" data-id="element-31">
        <div className="inline-block bg-gold-dark/20 border border-gold-primary/50 text-gold-light px-4 py-1 rounded-full text-sm font-medium tracking-widest uppercase mb-6" data-id="element-32">
          Gratis por hoy
        </div>
        <h2 className="font-cormorant text-4xl md:text-5xl text-gold-primary mb-12" data-id="element-33">
          🎁 TODO LO QUE RECIBÍS HOY
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 text-left" data-id="element-34">
          <div className="surface-gradient p-8 rounded-xl border border-gold-dark/20" data-id="element-35">
            <h3 className="font-cormorant text-2xl text-gold-light mb-4 border-b border-gold-dark/20 pb-4" data-id="element-36">
              Con el Grimorio Base
            </h3>
            <ul className="space-y-3" data-id="element-37">
              {baseBonuses.map((bonus, i) => <li key={i} className="flex items-center gap-3 text-text-primary" data-id="element-38">
                  <span className="text-gold-primary text-xl" data-id="element-39">✦</span>
                  {bonus}
                </li>)}
            </ul>
          </div>

          <div className="surface-gradient p-8 rounded-xl border border-gold-primary/40 relative overflow-hidden" data-id="element-40">
            <div className="absolute top-0 right-0 bg-gold-primary text-mystic-bg text-xs font-bold px-3 py-1 rounded-bl-lg uppercase tracking-wider" data-id="element-41">
              Solo en Aquelarre
            </div>
            <h3 className="font-cormorant text-2xl text-gold-light mb-4 border-b border-gold-dark/20 pb-4" data-id="element-42">
              Extra con El Aquelarre
            </h3>
            <ul className="space-y-3" data-id="element-43">
              {extraBonuses.map((bonus, i) => <li key={i} className="flex items-center gap-3 text-text-primary" data-id="element-44">
                  <span className="text-gold-primary text-xl" data-id="element-45">✦</span>
                  {bonus}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
};